import React from 'react';
import './PauseDispensingModal.css';

type Props = {
  onCancel: () => void;
  onConfirm: () => void;
};

const PauseDispensingModal: React.FC<Props> = ({ onCancel, onConfirm }) => {
  return (
    <div className="pdm-overlay" role="dialog" aria-modal="true" onClick={onCancel}>
      <div className="pdm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="pdm-title">
          Ertu viss um að þú viljir stöðva
          <br />
          lyfjaskömmtun sjúklings?
        </div>

        <div className="pdm-actions">
          <button className="pdm-cancel" type="button" onClick={onCancel}>
            Hætta við
          </button>

          <button className="pdm-confirm" type="button" onClick={onConfirm}>
            Staðfesta
          </button>
        </div>
      </div>
    </div>
  );
};

export default PauseDispensingModal;
